import { Table } from "./Table";
import { Form } from "./Form";

export const Company = {
  Table,
  Form,
};
